export enum StoryFilterGroupType {
  Visiblity = 1,
  TagCategory = 2,
  State = 3,
  ClientName = 4,
}
